import '../../sass/plugins/our_story.scss';

import { EXTRA_SMALL_SCREEN, LARGE_SCREEN, SMALL_SCREEN } from '../consts';

$(() => {
  const nextArrow = $('#our-story-next-arrow');
  const prevArrow = $('#our-story-prev-arrow');

  $('.our-story-slider-nav').slick({
    slidesToShow: 3,
    infinite: false,
    centerPadding: '10px',
    asNavFor: '.slider-for-our-story-entry',
    centerMode: true,
    focusOnSelect: true,
    nextArrow,
    prevArrow,
    responsive: [
      {
        breakpoint: EXTRA_SMALL_SCREEN,
        settings: {
          centerPadding: '50px',
        },
      },
      {
        breakpoint: SMALL_SCREEN,
        settings: {
          centerPadding: '30px',
        },
      },
      {
        breakpoint: LARGE_SCREEN,
        settings: {
          centerPadding: '30px',
        },
      },
    ],
  });

  $('.slider-for-our-story-entry').slick({
    slidesToScroll: 1,
    infinite: false,
    arrows: false,
    fade: true,
    asNavFor: '.our-story-slider-nav',
  });
});
